
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/analytics/[id]",
      function () {
        return require("private-next-pages/analytics/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/analytics/[id]"])
      });
    }
  